// extracted by mini-css-extract-plugin
module.exports = {"formRow":"styles_formRow__3fWMb","typeKeyNameField":"styles_typeKeyNameField__KM8Gx","typeKeyEmojiField":"styles_typeKeyEmojiField__1WA5H"};